.logo {
    display: block;
    margin: auto;
    margin-bottom: calc(-1 * var(--space-m));
}